import { create } from "zustand"

type PortfolioStore = {
  showAboutModal: boolean
  setShowAboutModal: (show: boolean) => void
  showReportUserModal: boolean
  setShowReportUserModal: (show: boolean) => void
}

const usePortfolioStore = create<PortfolioStore>((set, get) => ({
  showReportUserModal: false,
  setShowReportUserModal: (show: boolean) => {
    set(() => ({ showReportUserModal: show, showActionsMenu: false }))
  },
  showAboutModal: false,
  setShowAboutModal: (show: boolean) => {
    set(() => ({ showAboutModal: show }))
  },
}))

export const usePortfolio = () => {
  const { setShowReportUserModal, showReportUserModal, showAboutModal, setShowAboutModal } = usePortfolioStore()

  return {
    showAboutModal,
    showReportUserModal,
    setShowAboutModal,
    setShowReportUserModal,
  }
}
